import React from 'react'

/**
 * PullBanner / CarryBanner — a matched pair of banners that visualise the
 * handshake between sessions.
 *
 *  - PullBanner (moss, ⇣) — opens an in-session card with items inherited
 *    from prep. "pulled N · from this morning's prep"
 *  - CarryBanner (clay, ↗) — closes an in-session card with items being
 *    seeded into next prep. "carries forward · into next week's prep"
 *
 * Always paired conceptually: if a card has a pull banner, the
 * corresponding card on the other side must show a carry banner of the
 * same items. The two are the same artifact moving across the timeline.
 *
 * Spec: claude_design/design-system/primitives.html §8.5
 */
export function PullBanner({ count, source = "from this morning's prep", className = '', ...rest }) {
  return (
    <div className={['pull-banner', className].filter(Boolean).join(' ')} {...rest}>
      <span className="pull-banner__arrow" aria-hidden="true">⇣</span>
      <span className="pull-banner__label">pulled {count}</span>
      {source && <span className="pull-banner__source">{source}</span>}
    </div>
  )
}

export function CarryBanner({ destination = "into next week's prep", className = '', ...rest }) {
  return (
    <div className={['carry-banner', className].filter(Boolean).join(' ')} {...rest}>
      <span className="carry-banner__arrow" aria-hidden="true">↗</span>
      <span className="carry-banner__label">carries forward</span>
      {destination && <span className="carry-banner__destination">{destination}</span>}
    </div>
  )
}
